package entities

import kotlinx.serialization.Serializable


@Serializable
data class User(
    val id: Int,
    val firstName: String,
    val lastName: String,
    val telegramName: String,
    val dateReg: String,
    val phone: String,
    val telegramId: Long,
    val role: String
)